import authAxios from "../common/authAxios";

class ContractService{
    baseUrl = "/contract";

    checkContract(){
        return authAxios.get(this.baseUrl + "/has-contract");
    }

    checkContractByUserId(userId){
        return authAxios.get(this.baseUrl + "/has-contract-secretary?userId=" + userId);
    }

    getContract(){
        return authAxios.get(this.baseUrl + "/");
    }

    getContractByUserId(userId){
        return authAxios.get(this.baseUrl + "/secretary?userId=" + userId);
    }
}

export default ContractService;